import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import CreateListing from './pages/create-listing';
import SearchResults from './pages/search-results';
import Login from './pages/login';
import HomepageDashboard from './pages/homepage-dashboard';
import ProductDetails from './pages/product-details';
import SubscriptionManagement from './pages/subscription-management';
import UserProfile from './pages/user-profile';
import AdvancedSearch from './pages/advanced-search';
import Register from './pages/register';
import PaymentProcessing from './pages/payment-processing';
import Shop from "pages/shop";
import Encheres from "pages/encheres";
import AuthScreen from "pages/auth-screen";
import Loader from "pages/loader";
import Rechercher from "pages/rechercher";
import DetailsEnchere from "pages/details-enchere";
import AllServices from "pages/all-services";
import ServiceDetail from "pages/service-detail";
import SellerProfileScreen from "pages/seller-profile-screen";
import NotificationsScreen from "pages/notification";
import Favoris from "pages/favoris";
import Bot from "pages/bot";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<HomepageDashboard />} />
        <Route path="/create-listing" element={<CreateListing />} />
        <Route path="/search-results" element={<SearchResults />} />
        <Route path="/login" element={<Login />} />
        <Route path="/homepage-dashboard" element={<HomepageDashboard />} />
        <Route path="/product" element={<ProductDetails />} />
        <Route path="/subscription-management" element={<SubscriptionManagement />} />
        <Route path="/user-profile" element={<UserProfile />} />
        <Route path="/advanced-search" element={<AdvancedSearch />} />
        <Route path="/register" element={<Register />} />
        <Route path="/payment-processing" element={<PaymentProcessing />} />
        <Route path="*" element={<NotFound />} />

         <Route path="/shop" element={<Shop />} />
          <Route path="/encheres" element={<Encheres />} />
          <Route path="/auth" element={<AuthScreen />} />
          <Route path="/loader" element={<Loader />} />
          <Route path="/rechercher" element={<Rechercher />} />
          <Route path="/details-enchere/:id" element={<DetailsEnchere />} />
          <Route path="/all-services" element={<AllServices />} />
          <Route path="/service-detail" element={<ServiceDetail />} />
          <Route path="/seller-profile" element={<SellerProfileScreen />} />
          <Route path="/notifications" element={<NotificationsScreen />} />
          <Route path="/favoris" element={<Favoris />} />
          <Route path="/bot" element={<Bot />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
